/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import {
  Collapse,
  Divider,
  Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, MenuItem,
} from '@material-ui/core'
import getDomain from '@config/domain'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import StoreIcon from '@material-ui/icons/Store'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import { useHistory, useLocation } from 'react-router-dom'
import icons from '@assets/icons'
import { menu } from '@routes/menu'
import application from '@config/application'
import useWidth from '@hooks/useWidth'
import Cookies from 'js-cookie'
// import { matchDomain } from '@config/helpers'
import { useFeature } from '@hooks/useFeature'
import Badge from '@material-ui/core/Badge'
import { withStyles } from '@material-ui/core/styles'
import { useNotification } from '@hooks/useNotification'
import { useSnackbar } from 'notistack'
import useStyles from './sidebar-jss'

const Sidebar = ({ open, toggleDrawer }) => {
  const classes = useStyles()
  const location = useLocation()
  const { isPreOrder, isMemberReports } = useFeature()
  const { notification } = useNotification()
  const { badge_count } = notification
  const [selectedIndex, setSelectedIndex] = useState(location.pathname.replace(`${application.prefix + application.path}/`, ''))
  const [selectedIndexChild, setSelectedIndexChild] = useState(location.pathname.replace(`${application.prefix + application.path}/`, ''))
  const [collapse, setCollapse] = useState(false)
  const history = useHistory()
  const width = useWidth()
  const scope = Cookies.get('scope')
  if (!scope || !menu[scope]) {
    history.push(application.prefix)
    history.go(0)
  }
  const benefitType = JSON.parse(localStorage.getItem('payload'))?.benefit_type || ''
  const resellerDropship = JSON.parse(localStorage.getItem('payload'))?.dropship || false
  const canHasChild = JSON.parse(localStorage.getItem('payload'))?.is_have_childrens
  const noMember = JSON.parse(localStorage.getItem('payload'))?.no_member || ''
  const storefrontActive = JSON.parse(localStorage.getItem('payload'))?.is_store_front || ''
  const storeName = localStorage.getItem('store_name') || 'Store'
  const [openStore, setOpenStore] = useState(false)
  const [hiddenMenus, setHiddenMenus] = useState([])
  const { enqueueSnackbar } = useSnackbar()

  const StyledBadge = withStyles((theme) => ({
    badge: {
      right: -20,
      top: 15,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }))(Badge)

  useEffect(() => {
    const newHiddens = []
    if (!isPreOrder) {
      newHiddens.push('pre-order')
    }
    if (!isMemberReports) {
      newHiddens.push(...['member-purchase-reports', 'member-sales-reports'])
    }
    setHiddenMenus(newHiddens)
  }, [])

  const handleClick = () => {
    setOpenStore(!openStore)
  }

  const handleListItemClick = (event, index, link) => {
    setSelectedIndex(index)
    if (link) {
      history.push(`${application.prefix + application.path}${link}`)
      setCollapse(false)
    }
    if (!link) setCollapse(!collapse)
    if (['sm', 'xs'].includes(width) && link) toggleDrawer()
  }

  const handleChildListItemClick = (event, index, link) => {
    setSelectedIndexChild(index)
    if (['sm', 'xs'].includes(width)) toggleDrawer()
    history.push(`${application.prefix + application.path}${link}`)
  }

  const handleMyAccount = () => {
    history.push(`${application.prefix + application.path}/account`)
    toggleDrawer()
  }

  const handleChangePassword = () => {
    history.push(`${application.prefix + application.path}/change-password`)
    toggleDrawer()
  }

  const handleLogout = () => {
    if (scope === 'affiliate') {
      history.push(`${application.prefix}/affiliate`)
    } else {
      history.push(`${application.prefix}/login`)
    }
  }

  return (
    <div className={classes.root}>
      <Drawer
        variant="persistent"
        anchor="left"
        open={open}
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton
            onClick={toggleDrawer}
            className={classes.drawerButton}
          >
            {
            open
              ? <ArrowBackIosIcon className={classes.drawerButtonIcon} />
              : <ArrowForwardIosIcon className={classes.drawerButtonIcon} />
}
          </IconButton>
          {/* {
          matchDomain(window.location.hostname)
          && (
          <img
            src={icons.AppLogoWhite}
            height={138}
            width={110}
            alt="logo"
            className={classes.logo}
          />
          )
        } */}
          <div style={{ width: 110, height: 138 }} />
          <h2 className={classes.logoText}> SQUIDS </h2>
        </div>
        <div className={classes.drawerContent}>
          <List className={classes.list}>
            {
              menu[scope].map((item) => !hiddenMenus?.includes(item?.id) && (
                <div key={item.id}>
                  <ListItem
                    key={item.id}
                    button
                    className={classes.listItem}
                    selected={selectedIndex === item.id}
                    onClick={(event) => handleListItemClick(event, item.id, item.link)}
                    style={{ display: ((item?.hide_commision && benefitType !== 'Discount') || (item?.hide_discount && benefitType === 'Discount') || (item?.hide_dropship && resellerDropship) || (item?.hide_child && !canHasChild)) && 'none' }}
                  >
                    <ListItemIcon>
                      {item.icon}
                    </ListItemIcon>
                    {item?.has_notif ? (
                      <StyledBadge badgeContent={badge_count?.[item?.notif_id]} color="primary">
                        <ListItemText primary={item.title} />
                      </StyledBadge>
                    ) : (
                      <ListItemText primary={item.title} />
                    )}
                    {
                    item.child
                    && (collapse ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />)
                  }
                  </ListItem>

                  {
                    item.child
                    && (
                    <Collapse in={collapse && (selectedIndex === item.id)} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {
                          item.child.map((child) => (
                            <ListItem
                              key={child.id}
                              button
                              onClick={(e) => handleChildListItemClick(e, child.id, child.link)}
                              selected={selectedIndexChild === child.id}
                              className={classes.nested}
                            >
                              <ListItemIcon>
                                {child.icon}
                              </ListItemIcon>
                              <ListItemText primary={child.title} />
                            </ListItem>
                          ))
                        }
                      </List>
                    </Collapse>
                    )
                  }
                </div>
              ))
            }
            {
              storefrontActive && (
                <div
                  key="mystore"
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 16px', cursor: 'pointer',
                  }}
                >
                  <div
                    key="mystore"
                    className={classes.listItem}
                    style={{ display: 'flex', alignItems: 'center' }}
                    title={storeName}
                    onClick={() => {
                      window.open(`https:${getDomain()}/?ref=${noMember}`, '_blank')
                    }}
                  >
                    <ListItemIcon>
                      <StoreIcon />
                    </ListItemIcon>
                    <ListItemText primary="Toko Saya" />
                  </div>
                  <div
                    id="iconed"
                    style={{
                      display: 'flex',
                      height: '40px',
                      width: '100px',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                    onClick={() => {
                      navigator.clipboard.writeText(`https:${getDomain()}/?ref=${noMember}`)
                      enqueueSnackbar('Link toko refferal Anda telah disalin', { variant: 'success' })
                    }}
                  >
                    <FileCopyIcon />
                  </div>
                </div>
              )
            }
          </List>
        </div>
        <div className={classes.mobileMenuUser}>
          <Divider className={classes.userMenuDivider} />
          <List
            component="nav"
            // className={classes.root}
          >
            <ListItem onClick={handleClick}>
              <ListItemIcon>
                <StoreIcon />
              </ListItemIcon>
              <ListItemText primary={window.location.hostname} style={{ marginLeft: -16 }} />
              {openStore ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openStore} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button style={{ marginLeft: 16 }}>
                  <ListItemIcon>
                    <StoreIcon />
                  </ListItemIcon>
                  <ListItemText primary="Starred" style={{ marginLeft: -16 }} />
                </ListItem>
              </List>
            </Collapse>
          </List>
          <Divider className={classes.userMenuDivider} />
          <MenuItem onClick={handleMyAccount}>
            <ListItemIcon>
              <img
                src={icons.UserIcon}
                alt="user"
                height={18}
                width={18}
              />
            </ListItemIcon>
            <ListItemText primary="Akun Saya" style={{ marginLeft: -16 }} />
          </MenuItem>
          <MenuItem onClick={handleChangePassword}>
            <ListItemIcon>
              <img
                src={icons.KeyIcon}
                alt="user"
                height={18}
                width={18}
              />
            </ListItemIcon>
            <ListItemText primary="Ubah Kata Sandi" style={{ marginLeft: -16 }} />
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <img
                src={icons.LogoutIcon}
                alt="user"
                height={18}
                width={18}
              />
            </ListItemIcon>
            <ListItemText primary="Keluar" style={{ marginLeft: -16 }} />
          </MenuItem>
        </div>
      </Drawer>
    </div>
  )
}

Sidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
}

export default Sidebar
